if (window.location.href.toString().indexOf("saul-bass-archive") >= 0) {
  var __isp_options = {
    isp_smart_nav_avoid_collection_in_product_url: true,
    isp_serp_callback: function(data, facets_only) {
      $jquery_isp.each(ISP_PRODUCTS,function(id,el) {
        if (el.vra) {
          var size = $jquery_isp.map(el.vra[0][1],function(a){if(a[0]=="Size"){return a[1]}}); 
          var year = $jquery_isp.map(el.vra[0][1],function(a){if(a[0]=="Year"){return a[1]}}); 
          var price =$jquery_isp.map(el.vra[0][1],function(a){if(a[0]=="Price"){return a[1]}}); 
          var item = $jquery_isp('li.isp_grid_product[product_id='+id+']');
          var desc = item.find('.isp_product_desc');
          var soldOut = item.find('.isp_sold_out_banner_container');
          if (item.find('.isp_product_price2').length == 0 && $jquery_isp('.account-link').length > 0 && !el.iso) {
            desc.after($jquery_isp('<br><div class="isp_product_price2"></div>').text(price))
          }
          if (item.find('.isp_product_size').length==0) {
            desc.after($jquery_isp('<br><div class="isp_product_size"></div>').text(size))
          }
          if (item.find('.isp_product_year').length==0) {
            desc.after($jquery_isp('<br><div class="isp_product_year"></div>').text(year))
          }
          if (soldOut.length > 0 && item.find('.isp_product_out_of_stock').length == 0) {
		  	desc.after($jquery_isp('<br><div class="isp_product_out_of_stock" style="border: 1px solid white; margin-inline: auto; width: 130px;"></div>').text('INQUIRE'));
		  }
          item.find('.isp_product_info').addClass('product-info inside');
          item.find('.isp_product_price_wrapper');
        }
      });
      $jquery_isp('.isp_product_price_wrapper').hide();
      $jquery_isp.each($jquery_isp('.isp_product_info .isp_product_image_href'),function(i,el) {
        var title = $(el).find('.isp_product_title').clone();
        var wr = $jquery_isp(el).closest('.isp_product_info');
        $jquery_isp(el).remove();
        wr.prepend(title).parent().find('.isp_product_image_href:first').append(wr);
      });
      
      $jquery_isp('.isp_grid_product').each(function() {
		$jquery_isp(".isp_sold_out_banner_content").text('INQUIRE');
	  });
    },
    dropdown_narrow_by: [],    
    AVOID_POP_PRODUCTS_PRELOAD: false
  }
  __isp_options.dropdown_narrow_by = [["Type","SBA - Silk Screen"],["Type","SBA - Non-Film Poster"]];
} else {
  var __isp_options = {
    isp_smart_nav_avoid_collection_in_product_url: true,
    isp_serp_callback: function(data, facets_only) {      
      $jquery_isp(".isp_product_info").attr("class", "isp_product_info product-info inside");
      $jquery_isp.each(ISP_PRODUCTS,function(id,el) {
        if (el.vra) {
          var size = $jquery_isp.map(el.vra[0][1],function(a){if(a[0]=="Size"){return a[1]}}); 
          var year = $jquery_isp.map(el.vra[0][1],function(a){if(a[0]=="Year"){return a[1]}}); 
          var price =$jquery_isp.map(el.vra[0][1],function(a){if(a[0]=="Price"){return a[1]}}); 
          var item = $jquery_isp('li.isp_grid_product[product_id='+id+']');
          var desc = item.find('.isp_product_desc');
		  var soldOut = item.find('.isp_sold_out_banner_container');
          if (item.find('.isp_product_price2').length==0 && $jquery_isp('.account-link').length>0 && !el.iso) {
            desc.after($jquery_isp('<br><div class="isp_product_price2"></div>').text(price))
          }
          if (soldOut.length > 0 && item.find('.isp_product_out_of_stock').length == 0) {
		  	desc.after($jquery_isp('<br><div class="isp_product_out_of_stock" style="border: 1px solid white; margin-inline: auto; width: 130px;"></div>').text('INQUIRE'));
		  }
          if (item.find('.isp_product_size').length==0) {
            desc.after($jquery_isp('<br><div class="isp_product_size"></div>').text(size))
          }
          if (item.find('.isp_product_year').length==0) {
            desc.after($jquery_isp('<br><div class="isp_product_year"></div>').text(year))
          }
          item.find('.isp_product_info').addClass('product-info inside');
          item.find('.isp_product_price_wrapper');
        }
      });
      $jquery_isp('.isp_product_price_wrapper').hide();
      $jquery_isp.each($jquery_isp('.isp_product_info .isp_product_image_href'),function(i,el) {
        var title = $jquery_isp(el).find('.isp_product_title').clone();
        var wr = $jquery_isp(el).closest('.isp_product_info');
        $jquery_isp(el).remove();
        wr.prepend(title).parent().find('.isp_product_image_href:first').append(wr)
      });
      
      $jquery_isp('.isp_grid_product').each(function() {
		$jquery_isp(".isp_sold_out_banner_content").text('INQUIRE');
	  });
    }
  }
}

setTimeout(function() {
  $('.index.template-index .slick-slide .sold-out').find('.grid-link__meta').hide()
}, 5000);

var isp_related_options = {
    isp_related_callback: function() {
        $jquery_isp('.isp_related_product').each(function() {
            var id = $jquery_isp(this).attr('isp_product_id');
            if (ISP_RELATED_PRODUCTS[id].iso) {
                $jquery_isp(this).find('.isp_related_product_price').hide();
            }
        });
    }
};